import type {
  AuthoredEntityOrSingleSchema,
  LoadedAuthoredGeneratedSchema
} from '@cli-types/core-engine/add-field.js'
import type { CreateSchemaKind } from '@cli-types/core-engine/commands.js'
import type { FormSchema, SchemaField } from '@cli-types/core-engine/schema.js'
import { CREATE_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { promptField } from '../schema-prompts/prompt-field.js'
import { createFieldPromptOptions } from './create-field-prompt-options.js'
import { promptFormField } from './prompt-form-field.js'
import { promptSchemaSlotField } from './prompt-schema-slot-field.js'

export async function promptAdditionalCreateField(
  kind: CreateSchemaKind,
  schemasDir: string,
  schema: LoadedAuthoredGeneratedSchema['schema']
): Promise<void> {
  if (kind === 'form') {
    const formSchema = schema as FormSchema
    formSchema.fields = formSchema.fields ?? []
    await promptFormField(schemasDir, formSchema.fields)
    return
  }

  const entityOrSingleSchema = schema as AuthoredEntityOrSingleSchema
  if (entityOrSingleSchema.slot) {
    const mainFields = entityOrSingleSchema.slot.main?.fields ?? []
    const sidebarFields = entityOrSingleSchema.slot.sidebar?.fields ?? []
    await promptSchemaSlotField(kind, schemasDir, mainFields, sidebarFields)
    entityOrSingleSchema.slot = {
      main: { fields: mainFields },
      ...(sidebarFields.length > 0 ? { sidebar: { fields: sidebarFields } } : {})
    }
    return
  }

  const fields = entityOrSingleSchema.fields ?? []
  entityOrSingleSchema.fields = fields
  fields.push(
    (await promptField(
      CREATE_PROMPT_CONTEXT,
      kind,
      schemasDir,
      'schema',
      0,
      createFieldPromptOptions(fields)
    )) as SchemaField
  )
}
